// extracted by mini-css-extract-plugin
export default {"container":"Courses_container__Vkux+","navigation":"Courses_navigation__tYdz3","title":"Courses_title__pz46c","courses":"Courses_courses__JCRle"};